import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Linkedin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";
import { openConsentModal } from "@/lib/consent";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="relative z-10 bg-y5-ink border-t border-y5-line pt-24 pb-10">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <img src={IMAGES.fullLogo} alt="Yellow5" className="h-40 md:h-48 w-auto mb-6 -ml-2" />
            <p className="text-y5-muted max-w-sm leading-relaxed mb-6">{t.footer.tagline}</p>
            <a href="https://www.linkedin.com/company/yellow5/" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="inline-flex items-center gap-2 border border-y5-line px-4 py-2.5 text-y5-muted hover:border-y5-yellow hover:text-y5-yellow transition-colors">
              <Linkedin size={16} /> {t.footer.linkedin}
            </a>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-display text-sm uppercase tracking-widest text-white mb-6">{t.footer.nav}</h4>
            <ul className="space-y-3 text-y5-muted">
              <li><Link to="/services" className="hover:text-y5-yellow transition-colors">{t.footer.services}</Link></li>
              <li><Link to="/a-propos" className="hover:text-y5-yellow transition-colors">{t.footer.about}</Link></li>
              <li><Link to="/offres" className="hover:text-y5-yellow transition-colors">{t.footer.jobs}</Link></li>
              <li><Link to="/candidature" className="hover:text-y5-yellow transition-colors">{t.footer.spontaneous}</Link></li>
              <li><Link to="/login" className="hover:text-y5-yellow transition-colors">{t.footer.admin}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <h4 className="font-display text-sm uppercase tracking-widest text-white mb-6">{t.footer.contact}</h4>
            <div className="space-y-5 text-y5-muted">
              <div>
                <p className="text-white font-medium">Robin Josse</p>
                <a href="mailto:rjo@yellow5.be" className="flex items-center gap-2 hover:text-y5-yellow transition-colors mt-1"><Mail size={15} className="text-y5-yellow" /> rjo@yellow5.be</a>
                <a href="tel:+32470184726" className="flex items-center gap-2 hover:text-y5-yellow transition-colors mt-1"><Phone size={15} className="text-y5-yellow" /> +32 470 18 47 26</a>
              </div>
              <div>
                <p className="text-white font-medium">Antoine Bockiau</p>
                <a href="mailto:abo@yellow5.be" className="flex items-center gap-2 hover:text-y5-yellow transition-colors mt-1"><Mail size={15} className="text-y5-yellow" /> abo@yellow5.be</a>
                <a href="tel:+32498034671" className="flex items-center gap-2 hover:text-y5-yellow transition-colors mt-1"><Phone size={15} className="text-y5-yellow" /> +32 498 03 46 71</a>
              </div>
              <p className="flex items-start gap-2 pt-1"><MapPin size={15} className="text-y5-yellow mt-0.5 shrink-0" /> {t.contact.address}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-y5-line text-sm text-y5-muted">
          <span>© {new Date().getFullYear()} Yellow5. {t.footer.rights}</span>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 justify-center">
            <Link to="/politique-confidentialite" data-testid="footer-privacy" className="hover:text-y5-yellow transition-colors">
              {t.footer.privacy}
            </Link>
            <button type="button" onClick={openConsentModal} data-testid="footer-manage-cookies" className="hover:text-y5-yellow transition-colors">
              {t.footer.manageCookies}
            </button>
            <span className="font-display tracking-widest uppercase text-y5-muted/80">{t.footer.specialist}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
